import VideoRegistryABI from '../../../contracts/VideoRegistry.json';
import BettingManagerABI from '../../../contracts/BettingManager.json';
import addresses from '../../../contracts/addresses.json';

export type NetworkName = keyof typeof addresses;

export const getContractsByChainId = (chainId: number | undefined) => {
  // Find network by chainId
  const networkEntry = Object.entries(addresses).find(
    ([_, config]) => Number(config.chainId) === chainId
  );

  const config = networkEntry ? networkEntry[1] : addresses.hardhat;

  return {
    VideoRegistry: {
      address: config.contracts.VideoRegistry as `0x${string}`,
      abi: VideoRegistryABI.abi,
    },
    BettingManager: {
      address: config.contracts.BettingManager as `0x${string}`,
      abi: BettingManagerABI.abi,
    },
  } as const;
};

// Default for types and initial states
export const DEFAULT_CONTRACTS = getContractsByChainId(31337);

